import React from 'react';
import { ScrollView } from 'react-native';
import FullPageSimulator from '../../FullPageSimulator';
import {
  Expenses_str, Family_str, Fee_str, Rent_str,
} from '../../../../../utils/DictionaryManagementUtils';
import CurrencyAmountLine from '../../../AuxiliaryComponent/AmountSim/CurrencyAmountLine';

const ReferenceSelectReasonFP = ({
  globJSON, simPlatform, subCategoryId, TopTitle, WithGrayBackground, slideshowRefs,
}) => {
  const { reference } = globJSON.configurations.services[subCategoryId];
  const { colors } = globJSON.configurations.theme;
  const renderAllFields = () => (
    <CurrencyAmountLine
      globJSON={globJSON}
      currencyStr={reference.custom}
      simPlatform={simPlatform}
    />
  );
  return (
    <FullPageSimulator
      globJSON={globJSON}
      slideshowRefs={slideshowRefs}
      simPlatform={simPlatform}
      headlineText={reference.payment_reason}
      TopTitle={TopTitle}
      WithGrayBackground={WithGrayBackground}
    >
      <ScrollView
        style={{
          position: 'absolute',
          width: 240,
          backgroundColor: colors.app_background_color,
          borderTopWidth: 1,
          borderColor: colors.border_color,
        }}
        vertical
        pagingEnabled={false}
        showsVerticalScrollIndicator={false}
        scrollEnabled
      >
        <CurrencyAmountLine
          globJSON={globJSON}
          currencyStr={Rent_str}
          simPlatform={simPlatform}
        />
        <CurrencyAmountLine
          globJSON={globJSON}
          currencyStr={Expenses_str}
          simPlatform={simPlatform}
        />
        <CurrencyAmountLine
          globJSON={globJSON}
          currencyStr={Fee_str}
          simPlatform={simPlatform}
        />
        <CurrencyAmountLine
          globJSON={globJSON}
          currencyStr={Family_str}
          simPlatform={simPlatform}
        />
        {renderAllFields()}
      </ScrollView>
    </FullPageSimulator>
  );
};

export default ReferenceSelectReasonFP;
